<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>L’import a été effectué avec succès</span>
        </div>

        <div class="small-modal__body">
          <template v-if="!isSending">
            <table class="import-response">
            <tbody>
              <tr>
                <td class="title-td">Nombre total de garanties dans le fichier:</td>
                <td class="value-td">{{ result.total ? result.total.length : 0 }}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties importées:</td>
                <td class="value-td">{{ result.unique ? result.unique.length : 0 }}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties dupliquées:</td>
                <td class="value-td">{{ result.duplicates ? result.duplicates.length : 0 }}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties non importées:</td>
                <td class="value-td">{{ result.wrongs ? result.wrongs.length : 0 }}</td>
              </tr>
              <tr v-if="result.wrongs && result.wrongs.length > 0">
                <td class="title-td">Voulez-vous télécharger le fichier des garanties non importées ?</td>
                <td><button class="btn btn-info" @click="onWrongExport">Exporter</button></td>
              </tr>
              <tr v-if="result.duplicates && result.duplicates.length > 0">
                <td class="title-td">Voulez-vous télécharger le fichier des garanties dupliquées ?</td>
                <td><button class="btn btn-info" @click="onDuplicateExport">Exporter</button></td>
              </tr>
            </tbody>
          </table>
          </template>
          <template v-else>
            Loading...
          </template>
        </div>

        <div class="small-modal__footer">
          <div class="small-modal__footer__actions d-flex justify-content-between">
            <button class="blue-button" @click="$emit('close')">
              <span>Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  import Preloader from '@/components/Preloader'

  export default {
    name: 'GarantieResponseModal',
    components: {
      Preloader
    },
    props: {
      result: Object,
      isShown: Boolean,
      isDental: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isSending: false
      }
    },
    computed: {
      isDentalImport() {
        if (this.isDental) return true;
        if (this.result && this.result.duplicates && this.result.duplicates.length > 0) {
          const first = this.result.duplicates[0];
          if (first && (first.existing_quote_number !== undefined || first.serial !== undefined)) {
            return true;
          }
        }
        if (this.result && this.result.wrongs && this.result.wrongs.length > 0) {
          const first = this.result.wrongs[0];
          if (first && (first.serial !== undefined || first.reason !== undefined)) {
            return true;
          }
        }
        return false;
      }
    },
    watch: {
      'isShown' : function() {

      }
    },
    methods: {
      redirectForDownloading() {
        this.$emit('close');
      },
      onDuplicateExport() {
        this.isSending = true;
        let url = this.isDentalImport ? `dental/import/duplicates_prepare` : `guarantees/import/duplicates_prepare`;
        let ids = this.result.duplicates || [];

        this.apiPostFormData(url, {ids})
                .then(response => {
                  this.isSending = false;
                  let downloadUrl = this.isDentalImport ? `dental/import/duplicates_post_certified` : `guarantees/import/duplicates_post_certified`;
                  window.location.href = this.getApiAuthUrl(downloadUrl) + `&key=${response.data.key}`;
                })
                .catch(error => {
                  this.isSending = false;
                  this.showErrorNotification(error)
                });
      },
      onWrongExport() {
        this.isSending = true;
        let url = this.isDentalImport ? `dental/import/wrongs_prepare` : `guarantees/import/wrongs_prepare`;
        let data = {quotes : this.result.wrongs};

        this.apiPostFormData(url, data)
                .then(response => {
                  this.isSending = false;
                  let downloadUrl = this.isDentalImport ? `dental/import/wrongs_post_certified` : `guarantees/import/wrongs_post_certified`;
                  window.location.href = this.getApiAuthUrl(downloadUrl) + `&key=${response.data.key}`;
                })
                .catch(error => {
                  this.isSending = false;
                  this.showErrorNotification(error)
                });
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieResponseModal.vue